// extracted by mini-css-extract-plugin
export var banner = "_16-0";
export var icon = "_16-1";
export var message = "_16-2";